import { fromEnumAsStringOrNull, toEnumFromString } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { isNotNullOrUndefined } from '../../utility/null-safety.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/data-model.js';
import { isSameData } from '../dto/data-model-utils.js';
import { BusinessCategory } from './business-category.js';
import { BusinessModuleRef } from './business-module-ref.js';

export class PushNotificationIntent extends DataModel {
  static readonly TYPE_ID: string = '62641c8c76bd4e84a02558fe205eabc5';

  constructor(
    public readonly businessRef: BusinessModuleRef | null,
    public readonly businessCategory: BusinessCategory | null,
    public readonly url: string | null,
  ) {
    super();
  }

  get $typeId(): string {
    return PushNotificationIntent.TYPE_ID;
  }

  get isEmpty(): boolean {
    if(isNotNullOrUndefined(this.businessRef)) {
      return false;
    }

    if(isNotNullOrUndefined(this.businessCategory)) {
      return false;
    }

    if(isNotNullOrUndefined(this.url)) {
      return false;
    }

    return true;
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData
  ): PushNotificationIntent {
    return new PushNotificationIntent(
        BusinessModuleRef.decode(MapUtils.getOrNull<string>(map, 'businessRef')),
        toEnumFromString(MapUtils.getOrNull<string>(map, 'businessCategory'), BusinessCategory),
        MapUtils.getOrNull<string>(map, 'url'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      businessRef: this.businessRef?.encode() ?? null,
      businessCategory: fromEnumAsStringOrNull(this.businessCategory) ?? null,
      url: this.url ?? null,
    };
  }

  clone(): this {
    return new PushNotificationIntent(
        this.businessRef?.clone() ?? null,
        this.businessCategory ?? null,
        this.url ?? null,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.businessRef, this.businessRef) &&
        other.businessCategory === this.businessCategory &&
        other.url === this.url;
  }
}

export class PushNotificationIntentBuilder
  extends DataModelBuilder<PushNotificationIntent> {
  build(context: SerializationContext, map: SerializedData): PushNotificationIntent {
    return PushNotificationIntent.fromMap(context, map);
  }

  migrateToCurrentSchemaVersion(
      context: SerializationContext,
      map: SerializedData,
  ): SerializedData | null {
    this.migrateEnumOrNull(map, 'businessCategory', BusinessCategory, BusinessCategory.Other);

    return map;
  }
}
